import ReactDOM from 'react-dom/client';

import {AppIds} from '../constants';
import {AppComponentType, REACT_APP_LOADING_EVENT, RenderTriggerEvent} from './types';

// Method for render every react app
export const renderApp = (appId: AppIds, AppComponent: AppComponentType) => {
  const onPageLoadCallback = () => {
    const element = document.getElementById(appId);

    if (!element) {
      console.warn(`Render app initiated, but dom element with id #${appId} not found`);
      return false;
    }

    const root = ReactDOM.createRoot(element);
    const event: RenderTriggerEvent = new CustomEvent(REACT_APP_LOADING_EVENT, {
      detail: {
        AppComponent,
        root,
      },
    });

    document.dispatchEvent(event);
  };

  document.addEventListener('DOMContentLoaded', onPageLoadCallback);
};
